import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import LockingSystemZone   from "../../types/LockingSystemZone"
import {useLockingSystems} from "../../contexts/LockingSystemContext";
import NumberFormat        from "../common/Text/NumberFormat";

export interface props {
    item: LockingSystemZone
}

const ViewItemGroupLinked: React.FC<props> = ({item} ) => {

    const {t} = useTranslation()

    const {hasFeature: hasLockingSystemFeature} = useLockingSystems()

    const
        keysCount: number  = item !== undefined ? item.counts?.keys  || 0 : 0,
        locksCount: number = item !== undefined ? item.counts?.locks || 0 : 0,
        lockingSystemPermissionsCount: number = item !== undefined ? item.counts?.lockingSystemPermissions || 0 : 0,
        timeLimitsCount: number = item !== undefined ? item.counts?.timeLimits || 0 : 0

    return (
        <IonItemGroup>
            <IonItemDivider>{t('common.linked')}</IonItemDivider>
            <IonItem lines="full" button={keysCount > 0} detail={true}
                     routerLink={'/locking-system-zones/' + item?.id + '/keys'}>
                <IonLabel>{t('keys.title_list')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    <NumberFormat number={keysCount} />
                </IonNote>
            </IonItem>
            <IonItem lines="full" button={locksCount > 0} detail={locksCount > 0}
                     routerLink={'/locking-system-zones/' + item?.id + '/locks'}>
                <IonLabel>{t('locks.title_list')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    <NumberFormat number={locksCount} />
                </IonNote>
            </IonItem>
            <IonItem lines="full" button={lockingSystemPermissionsCount > 0}
                     detail={lockingSystemPermissionsCount > 0}
                     routerLink={'/locking-system-zones/' + item?.id + '/locking-system-permissions'}>
                <IonLabel>{t('locking-system-permissions.title_list')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    <NumberFormat number={lockingSystemPermissionsCount} />
                </IonNote>
            </IonItem>
            {hasLockingSystemFeature('HAS_TIME_LIMITS') === true &&
            <IonItem lines="full" button={timeLimitsCount > 0} detail={timeLimitsCount > 0}
                    routerLink={'/time-limits'}>
                <IonLabel>{t('time-limits.title_list')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{timeLimitsCount || '-'}</IonNote>
            </IonItem>
            }
        </IonItemGroup>
    )
}

export default ViewItemGroupLinked